import { render, staticRenderFns } from "./company-join.vue?vue&type=template&id=113d5686&"
import script from "./company-join.vue?vue&type=script&lang=js&"
export * from "./company-join.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports